import styledComp, { css, ThemeContext, } from 'styled-components';
import React, { useContext } from 'react';
import { useId } from '@react-aria/utils';
const styled = typeof styledComp === 'function'
    ? styledComp
    : styledComp.default;
const ClassNameConsumer = ({ className, children }) => children(className);
const IconClassNameProvider = styled(ClassNameConsumer)(({ theme, size }) => {
    if (size === 'illustrative') {
        return css `
      flex-shrink: 0;

      & > path {
        stroke-width: ${theme.styles.icons.strokeWidths.illustrative};
        vector-effect: non-scaling-stroke;
      }
    `;
    }
    return css `
    flex-shrink: 0;
  `;
});
const mergeClasses = (...classes) => classes.filter(Boolean).join(' ');
export const IconBase = ({ size = 'standard', color = 'inherit', title, name, className, render, ref, ...rest }) => {
    const ariaLabelledBy = useId();
    const theme = useContext(ThemeContext);
    const isBeameryLogo = name === 'beamery';
    return (React.createElement(IconClassNameProvider, { size: size }, (iconClassName) => render({
        ref,
        title,
        'data-name': name,
        titleId: ariaLabelledBy,
        color: theme.colors.text[color],
        role: title ? 'img' : 'presentation',
        width: isBeameryLogo
            ? theme.styles.icons.beameryIconSize.width
            : theme.styles.icons.sizes[size],
        height: isBeameryLogo
            ? theme.styles.icons.beameryIconSize.height
            : theme.styles.icons.sizes[size],
        'aria-hidden': title ? 'false' : 'true',
        'aria-labelledby': title && ariaLabelledBy,
        className: mergeClasses(iconClassName, className),
        ...rest,
    })));
};
